// extracted by mini-css-extract-plugin
export default {"noResultsContainer":"productList_noResultsContainer__-j7k+"};